import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  Icon,
  FormLabel,
  Input,
  Select,
  useDisclosure,
  SimpleGrid,
  useToast,
} from "@chakra-ui/react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
} from "@chakra-ui/react";
import { InputGroup, InputLeftElement, Flex } from "@chakra-ui/react";
import {
  FaPhone,
  FaUser,
  FaAt,
  FaBirthdayCake,
  FaIdCard,
  FaFileImage,
  FaGenderless,
  FaBriefcaseMedical,
  FaUserAlt,
} from "react-icons/fa";

import { FaEdit } from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../Globalapi/Globalapi";

const EditStudentModal = ({ studentId, onStudentUpdated }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [studentData, setStudentData] = useState({});
  const [loading, setLoading] = useState(false);
  const [genders, setGenders] = useState([]);
  const [bloodGroups, setBloodGroups] = useState([]);
  const toast = useToast();

  useEffect(() => {
    if (studentId) {
      fetchStudentDetails();
      fetchGenders();
      fetchBloodGroups();
    }
  }, [studentId]);

  const fetchStudentDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL}/admin/student/view_student.php?user_id=${studentId}`
      );
      setStudentData(response.data.data || {});
    } catch (error) {
      toast({
        title: "Error fetching student details.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchGenders = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/staff/gender_master.php`
      );
      setGenders(response.data.data || []);
    } catch (error) {
      toast({
        title: "Error fetching genders.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const fetchBloodGroups = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/staff/blood_group_master.php`
      );
      setBloodGroups(response.data.data || []);
    } catch (error) {
      toast({
        title: "Error fetching blood groups.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setStudentData((prevState) => ({ ...prevState, image: reader.result }));
    };
    if (file) {
      reader.readAsDataURL(file); // Convert image to base64
    }
  };

  const handleSubmit = async () => {
    // Validate required fields
    if (!studentData.name || !studentData.email) {
      toast({
        title: "Validation error.",
        description: "Name and email are required fields.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    // Prepare data to send
    const df = {
      user_id: studentId,
      name: studentData.name,
      address: studentData.address || "",
      date_of_birth: studentData.date_of_birth || "",
      gender: studentData.gender_id || "", // Use the gender value directly
      blood_group: studentData.blood_group_id || "", // Use the blood group value directly
      aadhar_no: studentData.aadhar_no || "",
      admission_number: studentData.admission_number || "",
      email: studentData.email,
      guardian: studentData.guardian_id || "",
      father_name: studentData.father_name || "",
      mother_name: studentData.mother_name || "",
      father_number: studentData.father_number || "",
      mother_number: studentData.mother_number || "",
      guardian: studentData.guardian_id || "",
      image: studentData.image || "", // Send the image in base64 format
    };
    console.log("edit object in frontent ",df);

    try {
      setLoading(true);
      const response = await axios.put(
        `${BASE_URL}/admin/student/edit_student.php`,
        df
      );

      console.log("edit data in backend :",response.data)

      if (response.data.success) {
        toast({
          title: "Student updated.",
          description: "The student details have been updated successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        onStudentUpdated(); // Refresh the student list
        onClose(); // Close the modal
      } else {
        throw new Error(response.data.message || "Failed to update student.");
      }
    } catch (error) {
      toast({
        title: "Error updating student.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Menu>
        <MenuItem
          p={0}
          icon={<FaEdit color="black" />}
          aria-label="Options"
          onClick={onOpen}
        >
          Edit
        </MenuItem>
      </Menu>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          {" "}
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaEdit} boxSize={5} mr={2} />
            Edit Student Details
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaUser} color="teal.500" style={{ marginRight: '8px' }} />
                Name
                </FormLabel>
                <Input
                  name="name"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.name || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaAt} color="teal.500" style={{ marginRight: '8px' }} />
                  Email
                </FormLabel>
                <Input
                  name="email"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.email || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaBriefcaseMedical} color="teal.500" style={{ marginRight: '8px' }} />

                  Address
                </FormLabel>
                <Input
                  name="address"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.address || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaBirthdayCake} color="teal.500" style={{ marginRight: '8px' }} />

                  Date of Birth
                </FormLabel>
                <Input
                  name="date_of_birth"
                  type="date"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.date_of_birth || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaIdCard} color="teal.500" style={{ marginRight: '8px' }} />
                  Aadhar No
                </FormLabel>
                <Input
                  name="aadhar_no"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.aadhar_no || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaIdCard} color="teal.500" style={{ marginRight: '8px' }} />
                  Admission No
                </FormLabel>
                <Input
                  name="admission_number"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.admission_number || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaUser} color="teal.500" style={{ marginRight: '8px' }} />
                  Father Name
                </FormLabel>
                <Input
                  name="father_name"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.father_name || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaUser} color="teal.500" style={{ marginRight: '8px' }} />
                  Mother Name
                </FormLabel>
                <Input
                  name="mother_name"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.mother_name || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaPhone} color="teal.500" style={{ marginRight: '8px' }} />
                  Father No
                </FormLabel>
                <Input
                  name="father_number"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.father_number || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaPhone} color="teal.500" style={{ marginRight: '8px' }} />
                  Mother No
                </FormLabel>
                <Input
                  name="mother_number"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.mother_number || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaUser} color="teal.500" style={{ marginRight: '8px' }} />
                  Guardian
                </FormLabel>
                <Input
                  name="guardian_id"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.guardian_name || ""}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaUserAlt} color="teal.500" style={{ marginRight: '8px' }} />

                  Gender
                </FormLabel>
                <Select
                  name="gender_id"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.gender_id || ""}
                  onChange={handleInputChange}
                >
                  {genders.map((gender) => (
                    <option key={gender.id} value={gender.id}>
                      {gender.gender}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaBriefcaseMedical} color="teal.500" style={{ marginRight: '8px' }} />

                  Blood Group
                </FormLabel>
                <Select
                  name="blood_group_id"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={studentData.blood_group_id || ""}
                  onChange={handleInputChange}
                >
                  {bloodGroups.map((group) => (
                    <option key={group.id} value={group.id}>
                      {group.group}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                <Icon as={FaFileImage} color="teal.500" style={{ marginRight: '8px' }} />

                  Upload Image
                </FormLabel>
                <Input
                  type="file"
                  accept="image/*"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  onChange={handleImageChange}
                />
              </FormControl>
            </SimpleGrid>

            {studentData.image && (
              <FormControl mb={4}>
                <FormLabel display="flex" alignItems="center">
                  <FaFileImage
                    color="teal.500"
                    style={{ marginRight: "8px" }}
                  />
                  Current Image
                </FormLabel>
                <img src={studentData.image} alt="Student" width="100" />
              </FormControl>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleSubmit}
              isLoading={loading}
            >
              Save
            </Button>
            {/* <Button onClick={onClose}>Cancel</Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EditStudentModal;
